import { forwardRef } from "react";
import { Icon } from "../icons/builder/IconBuilder";
import { useTheme } from "../../other/theme";
import styled from "@emotion/styled";

interface IIconButtonProps {
    icon: Icon;
    testId: string;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    onFocus?: (event: React.FocusEvent<HTMLElement>) => void;
    onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
    color?: string;
}

export const IconButton = forwardRef<HTMLButtonElement, IIconButtonProps>(
    function Forwarded({ icon, testId, onClick, onFocus, onBlur, color }, ref) {
        const theme = useTheme();

        return (
            <StyledIconButton
                onClick={onClick}
                onFocus={onFocus}
                onBlur={onBlur}
                data-testid={testId}
                ref={ref}
            >
                {icon({
                    size: 14,
                    color: color ?? theme.foreground
                })}
            </StyledIconButton>
        );
    }
);

const StyledIconButton = styled("button")({
    backgroundColor: "transparent",
    border: 0,
    padding: 5,
    fontSize: 0, // make sure font size doesn't increase container height
    opacity: 0.7,
    ":hover": {
        opacity: 1,
        cursor: "pointer"
    },
    "& + &": {
        paddingLeft: 1
    }
});
